module.exports = __webpack_public_path__ + "static/media/oberflex-cheneceruse-1200x2490.0d7ed51f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneceruse-1200x2490.jpg
// module id = 986
// module chunks = 37